export const sortIncidents = (incidents) => {
  if (!incidents) return [];
  return [...incidents].sort((a, b) => new Date(b.start_time) - new Date(a.start_time));
};

export const sortMaintenances = (maintenances) => {
  if (!maintenances) return [];
  return [...maintenances].sort((a, b) => new Date(b.start_time) - new Date(a.start_time));
};